import { ListItem, Typography } from '@mui/material';

const CopyRight = () => (
  <ListItem disablePadding>
    <Typography sx={{ fontSize: 10, color: '#333333', mt: 3 }}>
      Copyright © 2024 DKMediInfo.
      <br />
      All rights reserved.
    </Typography>
  </ListItem>
);

export default CopyRight;
